export default {
    name: 'MatchingRecordsTab',
    props: {
        recallData: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        allDuplicates() {
            if (!this.recallData?.duplicates_data || this.recallData.duplicates_data.length === 0) {
                return []
            }

            // Sort by provider_creation_date (most recent first)
            return [...this.recallData.duplicates_data].sort((a, b) => {
                const dateA = a.provider_creation_date ? new Date(a.provider_creation_date).getTime() : 0
                const dateB = b.provider_creation_date ? new Date(b.provider_creation_date).getTime() : 0

                // If both dates are missing, maintain original order
                if (dateA === 0 && dateB === 0) return 0

                // If one date is missing, put it at the end
                if (dateA === 0) return 1
                if (dateB === 0) return -1

                // Sort by date descending (most recent first)
                return dateB - dateA
            })
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return '-'
            try {
                const d = new Date(date)
                if (isNaN(d.getTime())) return '-'
                const month = String(d.getMonth() + 1).padStart(2, '0')
                const day = String(d.getDate()).padStart(2, '0')
                const year = d.getFullYear()
                return `${month}/${day}/${year}`
            } catch (error) {
                return '-'
            }
        },

        getFieldValue(value) {
            if (value === null || value === undefined || value === '') {
                return '<span class="missing-field">missing</span>'
            }
            return value
        },

        handleViewOriginal() {
            const recallId = this.recallData?.original_recall_data?.original_recall_id
            this.openRecallInNewTab(recallId)
        },

        handleViewDuplicate(duplicate) {
            this.openRecallInNewTab(duplicate?.duplicate_recall_id)
        },

        openRecallInNewTab(recallId) {
            if (!recallId) return
            try {
                const baseUrl = window.location.origin
                const url = `${baseUrl}/notisphere/recall-review/${recallId}`
                window.open(url, '_blank')
            } catch (error) {
                console.error('Error opening recall in new tab:', error)
            }
        }
    }
}
